import Alpine from 'alpinejs'

class QuantityInput extends HTMLElement {
  constructor () {
    super()

    this.line = this.dataset.line
    this.purchase_limit_error = this.querySelector('div.purchase-limit-error') || document.querySelector('div.purchase-limit-error[data-variant-id="' + this.dataset.variantId + '"][data-section="' + this.dataset.section + '"]') || document.querySelector('div.purchase-limit-error[data-variant-id="' + this.dataset.variantId + '"][data-line="' + this.dataset.line + '"]')
  }

  increaseQuantity (event) {
    event.preventDefault()
    if (this.increaseButton) {
      if (parseInt(this.input.value) <= parseInt(this.input.getAttribute('max'))) {
        this.input.stepUp()
      }
    }
    this.updateQuantity()
  }

  decreaseQuantity (event) {
    event.preventDefault()
    this.input.stepDown()
    this.updateQuantity()
  }

  showPurchaseLimitErrorMessage (error) {
    if (this.increaseButton) {
      this.increaseButton.classList.add('opacity-40')
    }
    this.purchase_limit_error.classList.remove('hidden')
    this.purchase_limit_error.setAttribute('aria-hidden', false)
    this.purchase_limit_error.innerHTML = error

    this.input.value = this.previousValue

    if (this.type === 'spinner') {
      this.increaseButton.classList.add('opacity-40')
    }
  }

  hidePurchaseLimitErorrMessage () {
    this.purchase_limit_error.classList.add('hidden')
    this.purchase_limit_error.setAttribute('aria-hidden', true)

    if (this.type === 'spinner') {
      this.increaseButton.classList.remove('opacity-40')
    }
  }

  updateQuantity () {
    let quantity = parseInt(this.input.value)
    if (this.input.getAttribute('x-model')) {
      const alpineModel = this.input.getAttribute('x-model')
      if (alpineModel.includes('quantity')) {
        this.input._x_model.set(quantity)
      }
    }
    const qtyChange = quantity - this.previousValue
    const limit = parseInt(this.input.max)

    if (qtyChange === 0 && quantity === limit) {
      // Brute Force Adding 1 to the input to force a purchase limit error if the limit is already hit
      quantity = quantity + 1
    }
    const cartDrawer = document.querySelector('cart-drawer')
    const cart = document.querySelector('cart-items')

    if (this.type === 'spinner') {
      if (quantity >= limit) {
        this.increaseButton.classList.add('opacity-40')
      } else {
        this.increaseButton.classList.remove('opacity-40')
      }
    }

    let gtmContent
    if ((cartDrawer && cartDrawer.contains(this)) || (cart && cart.contains(this))) {
      const cartItem = this.closest('.cart__item')
      const gtm_item_name = cartItem.querySelector('[name="gtm_item_name"]').getAttribute('value')
      // console.log(gtm_item_name)
      const gtm_item_id = cartItem.querySelector('[name="gtm_item_id"]').getAttribute('value')
      const gtm_item_variant = cartItem.querySelector('[name="gtm_item_variant"]').getAttribute('value')
      const gtm_item_upc = cartItem.querySelector('[name="gtm_item_upc"]').getAttribute('value')
      const gtm_item_price = cartItem.querySelector('[name="gtm_item_price"]').getAttribute('value')
      const gtm_component_ref = cartItem.querySelector('[name="gtm_component_ref"]').getAttribute('value')
      const gtm_item_brand = cartItem.querySelector('[name="gtm_item_brand"]')?.getAttribute('value') || ''
      const gtm_item_sku = cartItem.querySelector('[name="gtm_item_sku"]')?.getAttribute('value')
      const gtm_item_group_id = cartItem.querySelector('[name="gtm_item_group_id"]')?.getAttribute('value')
      const gtm_item_category = cartItem.querySelector('[name="gtm_item_category"]')?.getAttribute('value') || ''

      gtmContent = {
        item_name: gtm_item_name,
        item_id: gtm_item_id,
        item_collection: '',
        item_variant: gtm_item_variant,
        item_upc: gtm_item_upc,
        item_price: gtm_item_price,
        quantity: qtyChange,
        item_component_ref: gtm_component_ref,
      }

      if (window.shop_iso_code === 'DE') {
        Object.assign(gtmContent, {
          category: gtm_item_category,
          item_brand: gtm_item_brand,
          item_sku: gtm_item_sku,
          item_group_id: gtm_item_group_id,
        })
      }
    }

    if (cartDrawer && cartDrawer.contains(this)) {
      cartDrawer.updateQuantity(this.line, quantity, this.dataset.variantId, qtyChange, gtmContent)
    } else if (cart && cart.contains(this)) {
      cart.updateQuantity(this.line, quantity, this.dataset.variantId, qtyChange, gtmContent)
    }
  }

  getSectionsToRender () {
    return [
      {
        id: this.dataset.section
      }
    ]
  }

  renderContent (parsedState) {
    const id = `quantity-spinner[data-section="${this.dataset.section}"]`
    const html = new DOMParser().parseFromString(parsedState.sections[this.dataset.section], 'text/html')
    const destination = document.querySelector(id)
    const source = html.querySelector(id)

    if (source && destination) destination.outerHTML = source.outerHTML
  }
}

class QuantitySpinner extends QuantityInput {
  constructor () {
    super()

    this.type = 'spinner'

    this.input = this.querySelector('.js-quantity-spinner-input')
    this.previousValue = parseInt(this.input.value)

    this.input.addEventListener('change', this.updateQuantity.bind(this))

    this.increaseButton = this.querySelector('.js-quantity-spinner-increase')
    this.increaseButton.addEventListener('click', this.increaseQuantity.bind(this))

    this.decreaseButton = this.querySelector('.js-quantity-spinner-decrease')
    this.decreaseButton.addEventListener('click', this.decreaseQuantity.bind(this))

    if (parseInt(this.input.value) >= parseInt(this.input.max)) {
      this.increaseButton.classList.add('opacity-40')
    }
  }
}

customElements.define('quantity-spinner', QuantitySpinner)

class QuantitySelector extends QuantityInput {
  constructor () {
    super()

    this.type = 'selector'

    // console.log('quantity selector initialised', this)
    this.input = this.querySelector('select')
    // this.input.addEventListener('focus', function (e) {
    //   // console.log(e)
    //   console.log(this.value)
    //   // console.log(e.taget.value)
    // })
    this.previousValue = parseInt(this.input.value)
    this.addEventListener('change', this.onQuantityChange)
  }

  onQuantityChange (e) {
    // console.log(e, this.previousValue)
    this.updateQuantity()
  }
}

customElements.define('quantity-selector', QuantitySelector)
